import './Summary.scss'

import React from 'react'
import { useSelector } from 'react-redux'

import {
  hasSelectedTickets as hasSelectedTicketsSelector,
  isSerialTicketsMode as isSerialTicketsModeSelector
} from '../../selectors/selectors'
import CustomerLogin from './CustomerLogin/CustomerLogin'
import DesktopVouchers from './DesktopVouchers/DesktopVouchers'
import PaymentSection from './PaymentSection/PaymentSection'
import SelectedSerialTickets from './SelectedSerialTickets/SelectedSerialTickets'
import TotalPrice from './TotalPrice/TotalPrice'

export default function Summary() {
  const hasSelectedTickets = useSelector(hasSelectedTicketsSelector)
  const isSerialTicketsMode = useSelector(isSerialTicketsModeSelector)

  return (
    <div className="summary">
      <CustomerLogin />
      {hasSelectedTickets && (
        <>
          <SelectedSerialTickets />
          <TotalPrice />
          <hr />
          {isSerialTicketsMode && <DesktopVouchers />}
          <PaymentSection />
        </>
      )}
    </div>
  )
}
